export const conduitOptions = [
  { text: 'Conduit', value: 'Conduit' },
  { text: 'Tubería PVC', value: 'Tuberia PVC' },
  { text: 'Aérea ', value: 'Aerea' }
]

export const breakerOptions = [
  { text: 'Breaker y caja por cliente (std)', value: 'Breaker y caja por cliente' },
  { text: 'Breaker solamente por Accesos', value: 'Breaker solamente por Accesos' },
  { text: 'Breaker y caja por Accesos', value: 'Breaker y caja por Accesos' },
  { text: 'Breaker y caja intemperie por Accesos', value: 'Breaker y caja intemperie por Accesos' }
]

export const projectTypeOptions = [
  { text: 'Nuevo', value: 'Nuevo' },
  { text: 'Ampliación', value: 'Ampliacion' },
  { text: 'Sustitución', value: 'Sustitucion' },
  { text: 'Actualización', value: 'Actualizacion' },
]

export const systemTypeOptions = [
  { text: 'Centralizado', value: 'Nuevo' },
  { text: 'Autónomo', value: 'Autonomo' },
  { text: 'Híbrido', value: 'Hibrido' },
]

export const accessToControlOptions = [
  { text: 'Pasos Peatonales', value: 'peatonales' },
  { text: 'Pasos Vehiculares', value: 'vehiculares' },
]
// integration options

export const entryExitDevicesOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Lector de tags', text: 'Lector de tags' },
  { value: 'App móvil / Bluetooth', text: 'App móvil / Bluetooth' },
  { value: 'Control remoto', text: 'Control remoto' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const communicationDevicesOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Lector de tarjetas', text: 'Lector de tarjetas' },
  { value: 'Lector QR', text: 'Lector QR' },
  { value: 'Teclado numérico', text: 'Teclado numérico' },
  { value: 'Lector biométrico', text: 'Lector biométrico' },
  { value: 'Intercomunicador', text: 'Intercomunicador' },
  { value: 'Botón de salida', text: 'Botón de salida' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const sensorsOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Sensor infrarrojo BENINCA/CAME', text: 'Sensor infrarrojo BENINCA/CAME' },
  { value: 'Sensor láser LZR-i30', text: 'Sensor láser LZR-i30' },
  { value: 'Sensor láser LZR-H100', text: 'Sensor láser LZR-H100' },
  { value: 'lazo magnético SMA', text: 'lazo magnético SMA' },
  { value: 'Sensor radar Evoloop', text: 'Sensor radar Evoloop' },
  { value: 'Sensor radar Microbrain', text: 'Sensor radar Microbrain' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const boomLengthOptions = [
  { value: 0, text: '---Seleccionar---' },
  { value: 4, text: '4 m' },
  { value: 6, text: '6 m' },
  { value: 8, text: '8 m' },
  { value: 12, text: '12 m' }
]

export const alertsOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Semáforo', text: 'Semáforo' },
  { value: 'Zumbador', text: 'Zumbador' },
  { value: 'Estroboscópica', text: 'Estroboscópica' },
  { value: 'Intermitente', text: 'Intermitente' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const supportPostOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Fijo', text: 'Fijo' },
  { value: 'Móvil', text: 'Móvil' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const cerraduraOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Imán 600 lbs', text: 'Imán 600 lbs' },
  { value: 'Imán 600 lbs - doble', text: 'Imán 600 lbs - doble' },
  { value: 'Imán 1200 lbs', text: 'Imán 1200 lbs' },
  { value: 'Imán 1200 lbs - doble', text: 'Imán 1200 lbs - doble' },
  { value: 'Especial', text: 'Especial (ver notas)' },
]

export const tipoMontajeOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Montaje Z', text: 'Montaje Z' },
  { value: 'Montaje U vidrio-aluminio', text: 'Montaje U vidrio-aluminio' },
  { value: 'Montaje U vidrio-vidrio', text: 'Montaje U vidrio-vidrio' },
  { value: 'Especial', text: 'Especial (ver notas)' },
]

export const cerraduraPrincipalOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Barra antipánico', text: 'Barra antipánico' },
  { value: 'Elecyale', text: 'Elecyale' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const cerraduraBloqueosOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'El propio del sistema', text: 'El propio del sistema' },
  { value: 'Elemento adicional', text: 'Elemento adicional (ver notas)' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]

export const emergencyDevicesOptions = [
  { value: null, text: '---Seleccionar---' },
  { value: 'Botonera de enclave', text: 'Botonera de enclave' },
  { value: 'Botonera con cobertor y sirena', text: "Botonera con cobertor y sirena" },
  { value: 'Estación de emergencia Glass Break', text: 'Estación de emergencia Glass Break' },
  { value: 'Protector acrílico REBTI', text: 'Protector acrílico REBTI' },
  { value: 'Especial', text: 'Especial (ver notas)' },
  { value: 'N/A', text: 'N/A' }
]
